import React, { useEffect, useState } from 'react';
import { PiTrashDuotone } from 'react-icons/pi';
import { Button, Input } from 'rizzui';
import CustomSelect from '../../../../../components/forms/CustomSelect';
import { usePrivilege } from '../../../../../components/priviledge/PriviledgeProvider';
import useDocumentTypes from '../../../../../hooks/api-calls/useDocumentTypes';
import { FilterOptions } from '../../../../../hooks/useFilters';
import DateField from '../../../../../components/forms/DateField';
import { isEqual } from 'lodash';

interface ContractDocumentsFiltersProps {
    updateFilters: (filters: any) => void
    resetFilters: (limit: any) => void
    filters: FilterOptions
}

const ContractDocumentsFilters: React.FC<ContractDocumentsFiltersProps> = ({ filters, updateFilters, resetFilters }) => {

    const { getDocumentTypesList } = useDocumentTypes();

    return (
        <>

            <CustomSelect
                isSearchable
                isClearable
                id={'documentTypeId'}
                label="Tipo de documento"
                options={getDocumentTypesList()}
                onChange={(e: any) => { updateFilters({ document_type: e?.value }); }}
                value={getDocumentTypesList().find((g: any) => g.value === filters.filter_filters?.docuemnt_type)}
            />

            <DateField
                isClearable
                className="w-full"
                label="Fecha de Creación"
                placeholderText="Selecciona las fechas"
                startDate={filters.filter_filters?.between_dates?.startDate ? new Date(filters.filter_filters.between_dates.startDate) : null}
                endDate={filters.filter_filters?.between_dates?.endDate ? new Date(filters.filter_filters.between_dates.endDate) : null}
                onChange={(date: any) => {
                    const filters_between_dates = filters.filter_filters?.between_dates;
                    const between_dates = date ? { startDate: date[0], endDate: date[1] } : null;

                    if (between_dates && !isEqual(filters_between_dates, between_dates)) {
                        updateFilters({ between_dates: { startDate: date[0], endDate: date[1] } });
                    } else if (!between_dates && filters_between_dates) {
                        updateFilters({ between_dates: null });
                    }
                }}
            />


            <Button
                size="sm"
                onClick={() => {
                    resetFilters(50);
                }}
                variant="flat"
                className="h-9 bg-gray-200/70"
            >
                <PiTrashDuotone className="me-1.5 h-[17px] w-[17px]" /> Limpiar
            </Button>
        </>
    );
};

export default ContractDocumentsFilters;